import { render, staticRenderFns } from "./SessionExpiry.vue?vue&type=template&id=5586751d&scoped=true&"
import script from "./SessionExpiry.vue?vue&type=script&lang=js&"
export * from "./SessionExpiry.vue?vue&type=script&lang=js&"
import style0 from "./SessionExpiry.vue?vue&type=style&index=0&id=5586751d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586751d",
  null
  
)

export default component.exports